import { api } from './client';

export interface Notification {
  id: string; // BigInt serialised — keep as string for safety
  channel: 'in-app' | 'telegram' | 'email';
  target: string;
  subject: string | null;
  body: string;
  entityType: string | null;
  entityId: number | null;
  /** When present, the bell renders an "Open" link that navigates here on click. */
  actionHref?: string | null;
  sentAt: string | null;
  status: 'pending' | 'sent' | 'read' | 'failed';
  createdAt: string;
}

export async function listNotifications(opts: { status?: 'all' | 'unread'; limit?: number } = {}) {
  const r = await api.get<Notification[]>('/notifications', { params: opts });
  return r.data;
}

export async function unreadCount(): Promise<number> {
  const r = await api.get<{ count: number }>('/notifications/unread-count');
  return r.data.count;
}

export async function markRead(id: string | number): Promise<void> {
  await api.post(`/notifications/${id}/mark-read`);
}

export async function markAllRead(): Promise<{ updated: number }> {
  const r = await api.post<{ updated: number }>('/notifications/mark-all-read');
  return r.data;
}

export async function clearAllNotifications(): Promise<{ deleted: number }> {
  const r = await api.delete<{ deleted: number }>('/notifications');
  return r.data;
}

export interface HandoffPayload {
  moduleId: string;
  subject: string;
  body: string;
  entityType?: string;
  entityId?: number;
  /** Deep-link URL rendered as an "Open" button in the receiver's bell. */
  actionHref?: string;
}

export interface HandoffResult {
  recipients: number;
  roleNames: string[];
  moduleLabel: string | null;
}

/**
 * Fan out an in-app "please handle this" notification to every active user
 * who has permission on the target module. Used when the current user hits
 * a cross-module action they don't own (e.g. sales rep on the +GRN button).
 */
export async function handoffToModule(payload: HandoffPayload): Promise<HandoffResult> {
  const r = await api.post<HandoffResult>('/notifications/handoff', payload);
  return r.data;
}
